module.exports = __webpack_public_path__ + "assets/cb7c84baf40418235aef32a8bd1f89ed.png";